import { useContext } from 'react';
import { AuthContext } from '../contexts/Firebase';

export const useAuth = () => useContext(AuthContext);